module.exports = __webpack_public_path__ + "img/logss.0a7d86f2.png";